import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetIncomingInvoicesResponse } from '@/api/handlers/resources/purchases/responses';
import { PURCHASES_LIST_PAGE_SIZE } from '@/api/handlers/resources/purchases/queries';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

export const useIncomingInvoicesQuery = (
    pageSize = PURCHASES_LIST_PAGE_SIZE,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetIncomingInvoicesResponse>>({
        queryKey: PurchaseQueryKeys.incomingInvoices(pageSize),
        queryFn: () => apiClient.purchases.getIncomingInvoices({ pageSize }),
        enabled,
        staleTime: 60_000,
    });
};
